<template>
  <div>
    <div class="sub-header">Review And Publish</div>
    <div class="overflow-y-scroll scrollbar modal-height pb-4">
      <div class="inputs details">
        <div class="review-title">Fundraiser Title</div>
        <div
          class="review-info"
          data-test="fundraiser-title"
        >
          {{ fundraiserStore.fundraiserTitle }}
        </div>
        <div class="review-title">Created By</div>
        <div
          class="review-info"
          data-test="created-by"
        >
          {{ donorStore.donorFullName }}
        </div>
        <div class="review-title">Goal</div>
        <div
          class="review-info"
          data-test="goal"
        >
          {{ filters.formatMoney(fundraiserStore.goal) }}
        </div>
        <div class="review-title">Benefitting Organization</div>
        <div
          class="review-info"
          data-test="benefitting-org"
        >
          {{ chosenOrg }}
        </div>
        <div class="review-title">Custom URL</div>
        <div
          class="review-info"
          data-test="custom-url"
        >
          {{ fundraiserStore.urlLink }}
        </div>
        <div
          v-if="fundraiserStore.companyGiving"
          class="review-title"
        >
          Affiliated Company
        </div>
        <div
          v-if="fundraiserStore.companyGiving"
          class="review-info"
          data-test="affiliated-company"
        >
          {{ fundraiserStore.companyGiving.name }}
        </div>
        <div class="review-title">Fundraiser Story</div>
        <div
          class="review-info"
          data-test="fundraiser-story"
        >
          {{ fundraiserStore.story }}
        </div>
        <div class="review-title mb-2">Fundraiser Image</div>
        <div class="flex items-center flex-col md:items-start">
          <img
            :src="fundraiserStore.image || fundraiserStore.heroLink"
            class="preview-image"
            data-test="fundraiser-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, computed } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';
import { useFundraiserStore } from '@/stores/FundraiserStore.js';
import filters from '@/helpers/filters';

const donorStore = useDonorStore();
const fundraiserStore = useFundraiserStore();
const chosenOrg = ref('');

onBeforeMount(() => {
  if (fundraiserStore.benefittingOrg) {
    chosenOrg.value = fundraiserStore.benefittingOrg.organizationName;
  }
});
</script>
<style scoped>
.review-title {
  font-size: 12px;
  font-weight: 400;
}
.review-info {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 24px;
}
.preview-image {
  max-width: 200px;
  max-height: 200px;
  z-index: 2;
}

.details {
  text-align: left;
}
@media screen and (max-width: 768px) {
  .details {
    text-align: center;
  }
}
</style>
